import React from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';

export default function Forbidden() {
  useSEO({
    title: 'Ingen adgang · Vissenbjerg Bageri',
    description: 'Du har ikke adgang til denne side. Gå tilbage til forsiden og find vores lækre udvalg af brød og kager.'
  });

  return (
    <div className="bg-transparent text-chocolate min-h-[70vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-md space-y-6">
        <div className="text-copper text-7xl">
          <i className="fa-solid fa-lock" />
        </div>
        <h1 className="font-serif text-4xl font-bold text-chocolate sm:text-5xl">
          403 - Ingen adgang
        </h1>
        <p className="text-base text-chocolate/80 leading-relaxed">
          Beklager, men du har ikke tilladelse til at komme ind i denne del af bageriet. Kun bagerne har adgang her!
        </p>
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-gold-brown px-6 py-3 text-sm font-semibold text-cream hover:bg-copper transition-colors duration-200 shadow-md"
          >
            <i className="fa-solid fa-house" /> Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
